// removed by extract-text-webpack-plugin
module.exports = {"headerRow":"_1XSFSoIRCUi8Vp9djgsNQa","headerTitle":"_126akEB0Kqd3Rc-XJxxvaY","insidepane":"_1fOOKzPufkGxLIF1LrepCP","qpane":"_2ibgUM-E9oLyL-ncHM3ASn","qpaneSize":"_76ZMncYTglTnPGlGrghh6","question":"_1KorL-x7IM1sFKOZYw9VN6","gamble":"_14PtLkdToz5g6IN9ffiPTd","gambleBox":"tjhpN13sUoTSmHeWBnXur","answerButton":"_1uPGzuY1DA7NUbh1WXyisV","stepOn":"_1Ahar9rkX6S2foa1moX1X5","stepOff":"_1ol2dUqtv0-phrATEkukeT","trafficLight":"a50FlHiqZZROhHk0iLPdj","tl":"_1OKl7yBP3LfVpn3tqK9Qcw","tlGreen":"MrVDC8_aCR86ClurZoZgI","tlYellow":"_2u37f4Q0og69zO_mjEjujX","tlRed":"_1wDVldQ0ZSMxg_b9yyNZ_J"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ClientMode/LossAversionLight.css
// module id = 702
// module chunks = 0